<template>
  <div :id="name">
    <div class="action-part">
      <el-form :inline="true" size="medium">
        <el-form-item>
          <el-button type="primary" @click="showEditor(null)">创建识字</el-button>
        </el-form-item>
        <el-form-item>
          <el-input v-model="search.word" placeholder="请输入文字"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="search.enable" placeholder="请选择状态">
            <el-option value="0" label="下架"></el-option>
            <el-option value="1" label="上架"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="search.bookId" placeholder="请选择教材">
            <el-option :value="item.id" v-for="(item,index) in bookList" :key="index"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="doSearch">查 询</el-button>
          <el-button type="info" @click="doSearchCancel">重 置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="content-list">
      <el-table
          border
          :data="resultList"
          style="width: 100%">
        <el-table-column
            width="100"
            align="center"
            label="文字">
          <template slot-scope="scope">
                        <span v-text="scope.row.word"
                              style="font-size: 20px;"></span>
          </template>
        </el-table-column>
        <el-table-column
            label="图片"
            align="center"
            width="100">
          <template slot-scope="scope">
            <img :src="scope.row.images[0]" style="width: 90px;"
                 @click="showImagePreview(scope.row.images[0])">
          </template>
        </el-table-column>
        <el-table-column
            label="上/下架"
            align="center"
            width="120">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.enable" active-value="1" inactive-value="0"
                       @change="onEnableChange(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column
            label="视频"
            align="center"
            width="180">
          <template slot-scope="scope">
            <div class="word-item-video">
              <img :src="scope.row.videoCover"
                   style="width: 160px;height: 90px; vertical-align: middle;">
              <div class="video-cover" @click="playVideo(scope.row.videoId)">
                <span class="el-icon-video-play"></span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="ord"
            label="排序"
            align="center"
            width="80">
        </el-table-column>
        <el-table-column
            width="120"
            label="音频"
            align="center">
          <template slot-scope="scope">
            <el-button type="info" size="small"
                       @click="doItemPlay(scope.row.mp3Id)">播放音频
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
            label="教材名称">
          <template slot-scope="scope">
                        <span @click="toBookList(scope.row.bookId)"
                              style="cursor: pointer">《{{ scope.row.bookName }}》</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="createTime"
            width="150"
            align="center"
            label="创建时间">
        </el-table-column>
        <el-table-column
            align="center"
            width="180"
            label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="medium" @click="showEditor(scope.row)">编辑</el-button>
            <el-popconfirm
                confirm-button-text='马上删除'
                cancel-button-text='我后悔了'
                icon="el-icon-info"
                @confirm="deleteItem(scope.row.id)"
                icon-color="red"
                title="确定删除该文字吗？">
              <el-button slot="reference" type="danger" style="margin-left: 10px;" size="medium">
                删除
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page-part">
      <el-pagination
          size="small"
          background
          @current-change="loadByPage"
          :page-size="pagination.pageSize"
          :current-page="pagination.currentPage"
          layout="prev, pager, next"
          :total="pagination.total">
      </el-pagination>
    </div>
    <div class="dialog-part">
      <el-dialog :visible.sync="imagePreviewShow">
        <img width="100%" :src="previewImageUrl" alt="图片">
      </el-dialog>
      <el-dialog
          width="700px"
          center
          @close="videoPath=''"
          :visible.sync="videoPreviewShow">
        <video v-if="videoPath!==''" :src="videoPath" controls></video>
      </el-dialog>
      <word-editor ref="wordEditor"
                   @onPostWordSuccess="listContent"></word-editor>
    </div>
    <audio :src="targetPlayUrl" id="audio"></audio>
  </div>
</template>
<script>
import * as api from '../../api/api';
import wordEditor from '../../component/WordEditor';

export default {
  components: {
    wordEditor
  },
  data() {
    return {
      name: 'word',
      pagination: {
        pageSize: 0,
        total: 0,
        currentPage: 1,
        totalPage: 0
      },
      search: {
        word: '',
        bookId: '',
        enable: ''
      },
      resultList: [],
      imagePreviewShow: false,
      previewImageUrl: '',
      videoPreviewShow: false,
      videoPath: '',
      targetPlayUrl: '',
      bookList: []
    }
  },
  methods: {
    onEnableChange(item) {
      api.updateWordItem(item).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.$message.success(result.msg);
        } else {
          this.$message.error(result.msg);
        }
      })
    },
    deleteItem(wordId) {
      api.deleteWordItem(wordId).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.$message.success(result.msg);
          this.listContent();
        } else {
          this.$message.error(result.msg);
        }
      })
    },
    doItemPlay(mp3Id) {
      //去获取令牌
      api.getMp3PlayToken(mp3Id).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.targetPlayUrl = result.data.url;
          let audio = document.getElementById('audio');
          if (audio) {
            this.$nextTick(function () {
              audio.play();
            });
          }
        } else {
          this.$message.error(result.msg)
        }
      });
    },
    playVideo(videoId) {
      //去获取令牌
      api.getVideoToken(videoId).then(result => {
        console.log(result);
        if (result.code === api.SUCCESS_CODE) {
          this.videoPreviewShow = true;
          this.videoPath = result.data.url;
        }
      })
    },
    showImagePreview(url) {
      this.imagePreviewShow = true;
      this.previewImageUrl = url;
    },
    toBookList(bookId) {
      this.$router.push({
        path: '/word/book-detail',
        query: {
          bookId: bookId
        }
      })
    },
    doSearch() {
      this.pagination.currentPage = 1;
      this.listContent();
    },
    showEditor(item) {
      this.$refs.wordEditor.showWordEditorWithBookList(this.bookList, item);
    },
    doSearchCancel() {
      this.search.enable = '';
      this.search.word = '';
      this.search.bookId = '';
      this.doSearch();
    },
    loadByPage(page) {
      this.pagination.currentPage = page;
      this.listContent();
    },
    listContent() {
      api.listWord(this.pagination.currentPage, this.search).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          let data = result.data;
          this.resultList = data.list;
          this.pagination.currentPage = data.currentPage;
          this.pagination.pageSize = data.pageSize;
          this.pagination.total = data.total;
          this.pagination.totalPage = data.totalPage;
        }
      })
    },
    listBooks() {
      api.listBookSimple().then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.bookList = result.data;
        }
      })
    }
  },
  mounted() {
    this.listBooks();
    this.listContent();
  }
}
</script>
<style scoped>

.video-cover:hover {
  background: rgba(0, 0, 0, .5);
  color: white;
}

.video-cover {
  cursor: pointer;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
  font-size: 30px;
  left: 0;
  top: 0;
  position: absolute;
  background: rgba(0, 0, 0, .1);
}

.word-item-video {
  height: 90px;
  width: 160px;
  position: relative;
}

</style>
